import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {PAGES_AND_PATHS} from '../../constants/pages-and-paths';
import {AuthenticationHelperService} from '../../services/helpers/authentication-helper.service';
import {BusinessProfilesHttpService} from '../../services/http-services/business-profiles/business-profiles-http.service';
import {GeneralHelperService} from '../../services/helpers/general-helper.service';
import {distinctUntilChanged, takeUntil} from 'rxjs/operators';
import {Subject, Subscription} from 'rxjs';
import {NotificationsModelTypeAdmin} from '../../enums/notification-enums';
import {NotificationsHttpService} from '../../services/http-services/notifications/notifications-http.service';
import {WebsocketsHelperService} from '../../services/helpers/websockets-helper.service';
import {NotificationsHelperService} from '../../services/helpers/notifications-helper.service';

@Component({
  selector: 'gr-side-menu',
  templateUrl: './side-menu.component.html',
})
export class SideMenuComponent implements OnInit, OnDestroy {
  private newBusinessChange = new Subject<void>();
  private newBusinessPreviousValue: any;
  isPagesDropdownOpen = false;
  isBusinessUsersDropdownOpen = false;
  isLandingDropdownOpen = false;
  businessCategories: any[] = [];
  uncategorizedBusiness: any;
  notificationsCount = 0;
  unreadNotificationsCountSubscription = new Subscription();
  wsNotificationsSubscription = new Subscription();
  protected readonly PAGES_AND_PATHS = PAGES_AND_PATHS;

  constructor(public authHelper: AuthenticationHelperService,
              private generalHelper: GeneralHelperService,
              private _changeDetectorRef: ChangeDetectorRef,
              private notificationsHttpService: NotificationsHttpService,
              private websocketsHelperService: WebsocketsHelperService,
              private notificationsHelperService: NotificationsHelperService,
              private businessProfilesHttpService: BusinessProfilesHttpService) {
  }

  ngOnInit(): void {
    this.getBusinessCategories();
    this.setupSomeOfNewBusinessesChangeProfileData();
    this.getAllUnreadNotificationsCount();
    this.wsNotificationsSubscription = this.websocketsHelperService.notificationReceivedSubject.subscribe((res: any) => {
      console.log('wsNotificationsSubscription', res);
      this.notificationsCount++;
    });

    this.unreadNotificationsCountSubscription = this.notificationsHelperService.unreadNotificationsCountChange.subscribe((res: any) => {
      if (this.notificationsCount) {
        this.notificationsCount--;
      }
    });
  }

  ngOnDestroy(): void {
    this.unreadNotificationsCountSubscription.unsubscribe();
    this.wsNotificationsSubscription.unsubscribe();
    this.newBusinessChange.next();
    this.newBusinessChange.complete();
  }

  getAllUnreadNotificationsCount(): void {
    this.notificationsHttpService.getAllNotificationsCount().then((res: any) => {
      this.notificationsCount = res.unread_count;
    });
  }

  setupSomeOfNewBusinessesChangeProfileData(): void {
    this._changeDetectorRef.detectChanges();
    this.generalHelper.getChangeSomeBusinessProfile().pipe(
      distinctUntilChanged(),
      takeUntil(this.newBusinessChange)
    ).subscribe((value) => {
      if (this.uncategorizedBusiness && (!this.newBusinessPreviousValue || value.businessId !== this.newBusinessPreviousValue.businessId)) {
        this.uncategorizedBusiness.companies_count -= 1;
        this.businessCategories[value.categoryId - 1].companies_count += 1;
        this.newBusinessPreviousValue = value;
      }
    });
  }

  getBusinessCategories(): void {
    this.businessProfilesHttpService.getBusinessCategories().then(res => {
      this.businessCategories = res.data.data;
    });
    this.businessProfilesHttpService.getUncategorizedBusinesses().then(res => {
      this.uncategorizedBusiness =  res.data;
    });
  }

  handleOpenPagesDropdown(): void {
    this.isPagesDropdownOpen = !this.isPagesDropdownOpen;
  }

  handleOpenBusinessUsersDropdown(): void {
    this.isBusinessUsersDropdownOpen = !this.isBusinessUsersDropdownOpen;
  }
}
